import { render, staticRenderFns } from "./ProductPricingTable.vue?vue&type=template&id=45211240"
import script from "./ProductPricingTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPricingTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports